'use strict';

angular.module('ClinicApp').controller('ModalClinicInstantBookUpdate', function($scope, $modalInstance, $window, clinic, ClinicService, OpencareConstants) {

  function setModalToSeen() {
    return ClinicService.updateClinic(clinic, {
      metadata: {
        showInstantBookUpdateModal: false,
        showInstantBookUpdateModalUpdatedAt: moment().format(),
      },
    });
  }

  $scope.close = function() {
    return setModalToSeen()['finally'](function() {
      $modalInstance.close(false);
    });
  };

  $scope.openBookingSite = function() {
    $window.open(OpencareConstants.calendly.syncInstall, '_blank');
    return $scope.close();
  };

});
